export default {"src":"/_next/static/media/ic_chevronRight_black.5cf44538.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};